import Repository from "./Repository";

const subscriptionsEndpoint = "/gar-subscriptions";
const establishmentsEndpoint = "/gar-establishments";

export default {
  getSubscriptions: (params) =>
    Repository.get(`${subscriptionsEndpoint}/`, { params: params }),
  getSubscription: (id) => Repository.get(`${subscriptionsEndpoint}/${id}/`),
  createSubscription: (params) =>
    Repository.post(`${subscriptionsEndpoint}/`, { params: params }),
  updateSubscription: (params) =>
    Repository.patch(`${subscriptionsEndpoint}/${params.idAbonnement}/`, {
      params: params,
    }),
  deleteSubscription: (id) =>
    Repository.delete(`${subscriptionsEndpoint}/${id}/`),
  getEstablishments: (params) =>
    Repository.get(`${establishmentsEndpoint}/`, { params: params }),
};
